import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SideBarAdmin from '../../components/SideBarAdmin';
import { useAxios } from '../../utils/hook/useAxios';

const PAGE_SIZE = 20;

const STATUS_MAP = {
  0: { label: 'En attente', icon: 'bi-clock-history', color: 'text-warning' },
  1: { label: 'Approuvée', icon: 'bi-check2-circle', color: 'text-success' },
  2: {
    label: 'Rejetée',
    icon: 'bi-exclamation-circle-fill',
    color: 'text-danger',
  },
};

function AdminAnnonces() {
  const axios = useAxios();
  const [annonces, setAnnonces] = useState([]);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get('/vehicleAnnonces')
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setAnnonces(data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, []);

  const handleSearch = (val) => {
    setSearch(val);
    setPage(1);
  };
  const handleFilter = (val) => {
    setFilterStatus(val);
    setPage(1);
  };

  const filtered = annonces.filter((a) => {
    const matchStatus = filterStatus === 'all' || a.status === filterStatus;
    if (!matchStatus) return false;
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(a.vehiculeAnnonceId).includes(q) ||
      a.Vehicle?.VehicleModel?.marque?.toLowerCase().includes(q) ||
      a.Vehicle?.VehicleModel?.modele?.toLowerCase().includes(q) ||
      a.locationAddress?.toLowerCase().includes(q) ||
      a.UserProfile?.firstName?.toLowerCase().includes(q) ||
      a.UserProfile?.lastName?.toLowerCase().includes(q) ||
      a.UserProfile?.email?.toLowerCase().includes(q)
    );
  });

  const visible = filtered.slice(0, page * PAGE_SIZE);
  const hasMore = visible.length < filtered.length;

  return (
    <section className="bg-body-tertiary min-vh-100">
      <div className="container py-3 pb-5">
        <div className="row g-3">
          <div className="col-md-3 d-none d-md-block">
            <SideBarAdmin />
          </div>

          <div className="col-md-9">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h5 className="mb-0 fw-bold flex-grow-1">
                <i className="bi bi-megaphone-fill me-2 text-primary"></i>
                Annonces
              </h5>
              <span className="badge bg-secondary-subtle text-secondary rounded-pill px-3">
                {filtered.length} résultat{filtered.length !== 1 ? 's' : ''}
              </span>
            </div>

            {/* Barre recherche + filtre statut */}
            <div className="row g-2 mb-3">
              <div className="col">
                <div className="input-group">
                  <span className="input-group-text bg-white">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Rechercher par ID, marque, adresse, hôte…"
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  {search && (
                    <button className="btn btn-outline-secondary" onClick={() => handleSearch('')}>
                      <i className="bi bi-x"></i>
                    </button>
                  )}
                </div>
              </div>
              <div className="col-auto">
                <select
                  className="form-select"
                  value={filterStatus}
                  onChange={(e) => handleFilter(e.target.value)}
                >
                  <option value="all">Tous les statuts</option>
                  <option value="0">En attente</option>
                  <option value="1">Approuvées</option>
                  <option value="2">Rejetées</option>
                </select>
              </div>
            </div>

            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
              {isLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" />
                </div>
              ) : filtered.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="bi bi-inbox" style={{ fontSize: 36 }}></i>
                  <p className="mt-2 mb-0">Aucune annonce trouvée</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0 align-middle">
                    <thead className="table-light">
                      <tr>
                        <th style={{ fontSize: 12 }}>Date</th>
                        <th style={{ fontSize: 12 }}>Annonce</th>
                        <th style={{ fontSize: 12 }} className="d-none d-sm-table-cell">
                          Hôte
                        </th>
                        <th style={{ fontSize: 12 }}>Statut</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visible.map((item) => {
                        const s = STATUS_MAP[String(item.status)] ?? {
                          label: item.status,
                          icon: 'bi-circle',
                          color: 'text-secondary',
                        };
                        return (
                          <tr key={item.vehiculeAnnonceId}>
                            <td style={{ fontSize: 12 }} className="text-muted">
                              {moment(item.createdAt).format('DD/MM/YY')}
                            </td>
                            <td>
                              <Link
                                to={`/admin/annonces/${item.vehiculeAnnonceId}`}
                                className="fw-semibold text-decoration-none"
                                style={{ fontSize: 13 }}
                              >
                                #{item.vehiculeAnnonceId}
                              </Link>
                            </td>
                            <td className="d-none d-sm-table-cell" style={{ fontSize: 12 }}>
                              {item.UserProfile?.firstName} {item.UserProfile?.lastName}
                            </td>
                            <td>
                              <span style={{ fontSize: 12 }}>
                                <i className={`bi ${s.icon} ${s.color} me-1`}></i>
                                {s.label}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {hasMore && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-outline-primary rounded-pill px-4"
                  onClick={() => setPage((p) => p + 1)}
                >
                  <i className="bi bi-chevron-down me-2"></i>
                  Charger plus ({filtered.length - visible.length} restant
                  {filtered.length - visible.length > 1 ? 's' : ''})
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminAnnonces;
